import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';

import { STATUS_ENDPOINT } from 'app/constants';
import { environment } from 'environments/environment';

export interface StatusResponse {
    status: 'maintenance' | 'ok';
}

@Injectable()
export class MaintenanceService {
    private http = inject(HttpClient);

    readonly isMaintenanceMode = signal(false);

    setMaintenanceMode(value: boolean): void {
        this.isMaintenanceMode.set(value);
    }

    checkStatus(): Observable<StatusResponse | null> {
        return this.http
            .get<StatusResponse>(`${environment.apiUrl}${STATUS_ENDPOINT}`)
            .pipe(catchError(() => of(null)));
    }
}
